import React, { useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationControls from '../../components/PaginationControls';
import { getAllSectors, deleteSector, updateSector, createSector } from '../../API/Crud/Sector';
import ConfirmationModal from '../../components/ConfirmationModal';
import DashboardTemplate from '../template/DashboardTemplate';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { get, post, upload } from '../../services/ApiRouting';
import { useDropzone } from "react-dropzone";
import { BiEdit, BiTrash } from 'react-icons/bi';

function Sectors() {
  const [Categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [selectedSector, setSelectedSector] = useState(null);
  const { register, handleSubmit, control, reset, formState: { errors }, clearErrors } = useForm({
    defaultValues: {
      title: "",
      description: "",
    }
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });

  // Pagination logic
  const totalPays = Categories.length;
  const indexOfLastItem = totalPays - (currentPage - 1) * itemsPerPage;
  const indexOfFirstItem = Math.max(indexOfLastItem - itemsPerPage, 0);
  // const currentServices = Services.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => fetchSectors(pageNumber);
  const [showConfirmModal, setShowConfirmModal] = useState(false); // State to control confirmation modal visibility
  const [SectorToDelete, setSectorToDelete] = useState(null); // State to hold the Sector to be deleted

  useEffect(() => {
    const storedToken = sessionStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    } else {
      console.error('No token found');
      setError('No token found. Please log in.');
    }
  }, []);

  async function fetchSectors(page) {
    setLoading(true);
    try {
      const data = await getAllSectors(page);
      setCategories(data.data);
      setPagination({
        currentPage: data.current_page,
        perPage: data.per_page,
        total: data.total,
        lastPage: data.last_page,
      })
      setError(null);
    } catch (error) {
      setError(error.message || 'An unknown error occurred');
      toast.error('Failed to load Categories');
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (!token) return;

    fetchSectors(1);
  }, [token]);



  const handleDeleteSector = async (SectorId) => {
    try {
      const response = await deleteSector(SectorId);
      if (response.ok) {
        setCategories((prevCategories) => prevCategories.filter(Sector => Sector.id !== SectorId));
        toast.success('Sector deleted successfully');

      }
    } catch (error) {
      setError('Error deleting Sector');
      toast.error('Failed to delete Sector');
    }
  };

  useEffect(() => {
    if (selectedSector) {
      reset({
        title: selectedSector.title || "",
        description: selectedSector.description || "",
      });
    }
  }, [selectedSector, reset]);

  const handleEditSector = (Sector) => {
    setSelectedSector(Sector); // triggers useEffect above

    setFormData({
      id: Sector.id,
      title: Sector.title,
      description: Sector.description,

    });
    setShowEditModal(true);

  };

  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    title: '',
    description: '',

  });

  const onSubmit = async (data) => {
    console.log(data)
    const SectorData = {
      ...data,
    };
    try {
      const response = await createSector(SectorData);  // pass token + form data
      if (response.ok) {
        setShowModal(false);
        toast.success('Sector added successfully');
        setCategories((prevCategories) => [...prevCategories, response.data]);
      }
    } catch (error) {
      console.error("Error creating Sector:", error);
    }
  };

  const onUpdateSubmit = async (data) => {
    const SectorData = {
      ...data,
    };

    try {
      const response = await updateSector(selectedSector.id, SectorData);  // pass token + form data
      if (response.ok) {
        setShowEditModal(false);
        toast.success(response.message || 'Sector updated successfully');
        // Update the local state to reflect changes
        setCategories((prevCategories) =>
          prevCategories.map((cat) =>
            cat.id === selectedSector.id ? response.data : cat
          )
        );
        setSelectedSector(null); // Clear selected Sector after update
      }
    } catch (error) {
      console.error("Error creating Sector:", error);
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };
  const baseUrl = `${API_PUBLIC_URL}`;


  const handleConfirmDelete = () => {
    if (SectorToDelete) {
      handleDeleteSector(SectorToDelete.id);
      setShowConfirmModal(false);
      setSectorToDelete(null);
    }
  };

  const handleCancelDelete = () => {
    setShowConfirmModal(false);
    setSectorToDelete(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    reset()
    reset({}, { keepErrors: false, keepDirty: false, keepTouched: false });
  };

  const handleOpenModal = () => {
    setShowModal(true);
    reset()
    reset({}, { keepErrors: false, keepDirty: false, keepTouched: false });
  };

  return (
    <DashboardTemplate>
      <div className="flex flex-col">
        <ToastContainer />
        <div className="transition-all duration-500 flex-1">
          <div className="content p-2 md:p-5">

            {loading ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="w-10 animate-spin fill-orange-600 block mx-auto"
                viewBox="0 0 24 24">
                <path
                  d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
                  data-original="#000000" />
              </svg>
            ) : error ? (
              <p>Error: {error}</p>
            ) : (
              <div className="font-[sans-serif] ">
                <div className="flex justify-between items-center mb-4">
                  <h1 className="text-2xl font-bold text-gray-900">Sectors</h1>
                  <button className="bg-[#F2A549] font-normal text-black px-4 py-2 rounded cursor-pointer hover:bg-[#efb46f]" onClick={handleOpenModal}>
                    Add new Sector
                  </button>
                </div>
                <div className='w-auto max-w-full overflow-x-auto'>
                  <table className="border-collapse min-w-full  border border-gray-300 rounded-lg">
                    <thead className="bg-[#F2A549] text-white">
                      <tr className='text-center'>
                        <th className="p-4  font-normal text-black">Title</th>
                        <th className="p-4  font-normal text-black">Description</th>
                        <th className="p-4  font-normal text-black">Date</th>
                        <th className="p-4  font-normal text-black">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(Categories) && Categories.map((Sector) => (
                        <tr className="border border-gray-300" key={Sector.id}>
                          <td className="py-2 text-center text-sm border border-gray-300">{Sector.title}</td>
                          <td className="relative w-[20%] border border-gray-300 text-sm text-center">
                            <div className="w-[90px] truncate inline-block align-middle">
                              {Sector.description.replace(/<\/?p>/g, "")}
                            </div>
                          </td>
                          <td className=" text-sm border border-gray-300 text-center">{formatDate(Sector.created_at)}</td>
                          <td className="border border-gray-300 text-center ">
                            <div className='flex justify-center gap-4'>
                              <button className="cursor-pointer" name="Edit" onClick={() => handleEditSector(Sector)}>
                                <BiEdit size={25} />
                              </button>
                              <button className="cursor-pointer" name="Delete" onClick={() => {
                                setSectorToDelete(Sector)
                                setShowConfirmModal(true)
                              }}>
                                <BiTrash size={25} />

                              </button>
                            </div>
                          </td>
                        </tr>
                      )).reverse()}
                      {Categories.length === 0 && (
                        <tr>
                          <td colSpan="5" className="p-4 text-center text-gray-500 border border-gray-300">
                            There is no Sector.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                </div>
                {/* Create Modal */}
                <Dialog open={showModal} onClose={setShowModal} className="relative z-[9999]">
                  <DialogBackdrop transition className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in" />

                  <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-screen items-center justify-center p-4 text-center sm:items-center sm:p-0">
                      <DialogPanel transition className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full max-w-[70%] data-closed:sm:translate-y-0 data-closed:sm:scale-95" >
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div className="sm:col-span-4 mb-3">
                              <label htmlFor="title" className="block text-sm/6 font-medium text-gray-900">
                                Title
                              </label>
                              <div className="mt-2">
                                <input
                                  id="title"
                                  name="title"
                                  type="text"
                                  autoComplete="title"
                                  {...register('title', {
                                    required: 'Title is required',
                                  })}
                                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-[#F2A549] sm:text-sm/6"
                                />
                                {errors.title && (
                                  <span className="error-message">
                                    {errors.title.message}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="sm:col-span-4 mb-3">
                              <label htmlFor="description" className="block text-sm/6 font-medium text-gray-900">
                                Description
                              </label>
                              <div className="mt-2">
                                <Controller
                                  name="description"
                                  control={control}
                                  defaultValue=""
                                  rules={{ required: "Description is required" }}
                                  render={({ field }) => (
                                    <CKEditor
                                      editor={ClassicEditor}
                                      data={field.value}
                                      onChange={(event, editor) => {
                                        field.onChange(editor.getData());
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && (
                                  <span className="error-message">
                                    {errors.description.message}
                                  </span>)
                                }
                              </div>
                            </div>
                          </div>
                          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            <button
                              type="submit"
                              className="inline-flex cursor-pointer w-full justify-center rounded-md bg-[#F2A549] px-3 py-2 text-sm font-semibold text-black shadow-xs hover:bg-[#efb46f] sm:ml-3 sm:w-auto"
                            >
                              Create
                            </button>
                            <button
                              type="button"
                              data-autofocus
                              onClick={handleCloseModal}
                              className="mt-3 cursor-pointer inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                            >
                              Cancel
                            </button>
                          </div>
                        </form>
                      </DialogPanel>
                    </div>
                  </div>
                </Dialog>
                {/* Edit Modal */}
                <Dialog open={showEditModal} onClose={setShowEditModal} className="relative z-[9999]">
                  <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
                  />

                  <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-screen items-center justify-center p-4 text-center sm:items-center sm:p-0">
                      <DialogPanel transition className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full max-w-[70%] data-closed:sm:translate-y-0 data-closed:sm:scale-95" >
                        <form form onSubmit={handleSubmit(onUpdateSubmit)}>
                          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div className="sm:col-span-4 mb-3">
                              <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                Title
                              </label>
                              <div className="mt-2">
                                <input
                                  id="title"
                                  name="title"
                                  type="text"
                                  autoComplete="title"
                                  {...register('title', {
                                    required: 'title is required',
                                  })}
                                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-[#F2A549] sm:text-sm/6"
                                />
                                {errors.title && (
                                  <span className="error-message">
                                    {errors.title.message}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="sm:col-span-4 mb-3">
                              <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                Description
                              </label>
                              <div className="mt-2">
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{ required: "Description is required" }}
                                  render={({ field }) => (
                                    <CKEditor
                                      editor={ClassicEditor}
                                      data={formData.description}
                                      onChange={(event, editor) => {
                                        field.onChange(editor.getData());
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && (
                                  <span className="error-message">
                                    {errors.description.message}
                                  </span>)
                                }
                              </div>
                            </div>

                          </div>
                          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            <button
                              type="submit"
                              className="inline-flex w-full justify-center cursor-pointer rounded-md bg-[#F2A549] px-3 py-2 text-sm font-semibold text-black shadow-xs hover:bg-[#efb46f] sm:ml-3 sm:w-auto"
                            >
                              Update
                            </button>
                            <button
                              type="button"
                              data-autofocus
                              onClick={() => setShowModal(false)}
                              className="mt-3 inline-flex w-full cursor-pointer justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                            >
                              Cancel
                            </button>
                          </div>
                        </form>
                      </DialogPanel>
                    </div>
                  </div>
                </Dialog>
                <PaginationControls
                  itemsPerPage={pagination.perPage}
                  totalItems={pagination.total}
                  currentPage={pagination.currentPage}
                  paginate={paginate}
                />
              </div>
            )}

          </div>
        </div>

        <ConfirmationModal
          show={showConfirmModal}
          name={SectorToDelete ? SectorToDelete.title : ''}
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />
      </div>

    </DashboardTemplate>
  );
}

export default Sectors;
